import React from "react";
import { sortObjectsByAlphabet } from "../../utils";
//import { useHistory } from "react-router-dom";
//import { TableContext } from "../index";

function VulscanTypeField({ types = [], value, onChange }) {

    //const history = useHistory();
    //const { config, setConfig } = useContext(TableContext);

    // const onChange = (value) => {
    //     setTypeId("-1");
    //     setConfig({ ...config, typeId: value });

    //     if (typeId === "-1") {
    //         setConfig({ ...config, typeId: -1 });
    //         // const aryFilters = ['device', 'deviceType'];
    //         // history.push({
    //         //     pathname: history.pathname,
    //         //     search: urlService.removeFilters(aryFilters)
    //         // })
    //         return;
    //     }

    //     if (types) {
    //         const type = types.find(type => type.id === Number(value));

    //         if (!type) {
    //             setConfig({ ...config, typeId: -1 });
    //             return;
    //         }

    //         // history.push({
    //         //     pathname: history.pathname,
    //         //     search: urlService.replaceFilters('deviceType', deviceType.name)
    //         // })
    //     }
    // }

    const handleChange = async (id) => {
        let selectType = null;
        let details = '';
        let command = '';
        if (id > 0) {
            selectType = types.find(type => type.id === Number(id));
            // const sshAlgorithmText = await additionalAlgorithmService.getDeviceSSHAlgorithm(id);
            if (selectType.details) {
                details = selectType.details;
            } else {
                details = '';
            }
            if (selectType.command) {
                command = selectType.command;
            } else {
                command = '';
            }
        }
       
        // let disabledButton = true;
        // if (!selectDevice) {
        //     disabledButton = true;
        // } else {
        //     disabledButton = false;
        // }

        onChange(selectType, details, command);
    }

    const typesCopy = sortObjectsByAlphabet(types, 'type');

    return (
        <div className="network-scan-control-v2">
                <label className="network-scan-control-label-v2" htmlFor="scanType">Scan Type</label>
                <select className="network-scan-select-v2" id="scanType"
                    value={value ? value.id : 0}
                    onChange={event => handleChange(event.target.value)}>
                    <option value={0}>Choose</option>
                    {
                        typesCopy &&
                        typesCopy.map((type, index) => <option key={index} value={type.id}>{type.type}</option>)
                    }
                    {!types || types.length === 0 ?
                    <option value={0}>No scan types available</option> :
                    null
                }
                </select>
        </div>
    );
}


export default VulscanTypeField;
